'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ROUTES } from '@/utils/constants';
import { removeProductFromUid } from '@/utils/url/url';
import { useStore } from '@/store/store';
import { SvgLoader } from '../svg/loader';

import './styles/@theme';
import { getNavigatedToProps } from '@/tracking/amplitude/events/general/navigation-link-clicked';

type CategoryViewAllProps = {
    categoryUid: string;
    zoneName: string;
    isInfluencerEntryPoint?: boolean;
};

export const CategoryViewAll: React.FC<CategoryViewAllProps> = ({
    categoryUid,
    zoneName,
    isInfluencerEntryPoint = false
}) => {
    const currentPath = usePathname();
    const handleShowLoading = useStore((s) => s.loading.handleShowLoading);
    const { sendEvent } = useStore((state) => state.tracking);

    const categoryUrl = isInfluencerEntryPoint
        ? `${ROUTES.INFLUENCER_HUB}${categoryUid}`
        : `${ROUTES.CATEGORY}${removeProductFromUid(categoryUid)}`;

    if (!isInfluencerEntryPoint && currentPath?.startsWith(ROUTES.CATEGORY) && currentPath !== categoryUrl) {
        return null;
    }

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        const isPrimaryClick = event.button === 0;
        const isActive = currentPath === categoryUrl;

        const eventProps = getNavigatedToProps({
            module: zoneName,
            linkText: 'View all',
            linkUrl: categoryUrl
        });
        sendEvent([{ destination: 'amplitude', eventProps }]);

        if (isPrimaryClick) {
            if (isActive) {
                event.preventDefault();
                return;
            }
            handleShowLoading();
        }
    };

    return (
        <Link
            data-testid="category-view-all-button"
            className="category-view-all"
            href={categoryUrl}
            onClick={handleClick}
            prefetch={false}>
            View all <SvgLoader iconName="arrow-right" />
        </Link>
    );
};
